import React from 'react';
import style from './card.module.scss';
import pdfImage from '../../assets/pdf.png';

const renderCircleProgress = (score, maxScore) => {
  const percentage = Math.min((score / maxScore) * 100, 100);
  const radius = 42;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <div className={style.scoreCircle}>
      <svg viewBox="0 0 100 100">
        <circle className={style.scoreCircleBg} cx="50" cy="50" r={radius} />
        <circle
          className={style.scoreCircleFill}
          cx="50"
          cy="50"
          r={radius}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
        />
      </svg>
      <div className={style.scoreCircleText}>
        <span className={style.scoreCircleValue}>{score}</span>
        <span className={style.scoreCircleMax}>of {maxScore}</span>
      </div>
    </div>
  );
};

const Card = ({
  heading,
  children,
  className,
  pdfUrl,
  score,
  maxScore,
  desc,
  title,
  subtitle,
}) => {
  const handleDownloadPdf = () => {
    if (pdfUrl) {
      window.open(pdfUrl, '_blank');
    } else {
      alert('No PDF available to download.');
    }
  };

  const renderHeading = () => {
    if (typeof heading === 'string') {
      return <h3 className={style.cardHeading}>{heading}</h3>;
    }
    return heading;
  };

  return (
    <div className={`${className || ''} ${style.card1}`}>
      {renderHeading()}
      {score && maxScore && (
        <div className={style.biohyPointsWrapper}>
          <div className={style.biohyCard}>
            {renderCircleProgress(score, maxScore)}
            <div className={style.biohyTextContent}>
              <h4 className={style.biohyTitle}>{title}</h4>
              {subtitle && <p className={style.biohySubtitle}>{subtitle}</p>}
            </div>
          </div>
          {desc && (
            <div className={style.biohyDescriptionBox}>
              <p>{desc}</p>
            </div>
          )}
        </div>
      )}

      <div
        className={`${style.cardChild}  ${pdfUrl ? style.cardChildPdf : ''}`}
      >
        {pdfUrl ? (
          <>
            <div className={style.iframe}>
              <iframe
                src={`${pdfUrl}`}
                frameBorder="0"
                title="PDF"
                className={style.iframe}
              />
            </div>
            <div className={style.pdf_icon} onClick={handleDownloadPdf}>
              <img src={pdfImage} alt="pdfIcon" />
            </div>
          </>
        ) : (
          children
        )}
      </div>
    </div>
  );
};

export default Card;
